import { MessageSquare, HelpCircle, Search, Headphones } from "lucide-react";

type ChatCategory = "feedback" | "functionality" | "navigation" | "human_support";

interface SupportChatOptionsProps {
  onSelect: (category: ChatCategory) => void;
}

const options = [
  {
    category: "feedback" as ChatCategory,
    icon: MessageSquare,
    title: "Dar feedback ou sugestão",
    description: "Bug, sugestão de melhoria ou elogio",
    color: "text-blue-500",
    bg: "bg-blue-500/10",
  },
  {
    category: "functionality" as ChatCategory,
    icon: HelpCircle,
    title: "Dúvida sobre funcionalidade",
    description: "Como usar quiz, desafios, certificados...",
    color: "text-emerald-500",
    bg: "bg-emerald-500/10",
  },
  {
    category: "navigation" as ChatCategory,
    icon: Search,
    title: "Não estou achando algo",
    description: "Ajuda para encontrar o que precisa",
    color: "text-amber-500",
    bg: "bg-amber-500/10",
  },
];

export function SupportChatOptions({ onSelect }: SupportChatOptionsProps) {
  return (
    <div className="flex-1 p-4 overflow-y-auto">
      <p className="text-sm text-muted-foreground mb-4">
        Olá! 👋 Como posso te ajudar hoje?
      </p>
      <div className="space-y-2">
        {options.map(opt => (
          <button
            key={opt.category}
            onClick={() => onSelect(opt.category)}
            className="w-full flex items-start gap-3 p-3 rounded-xl border hover:bg-accent/50 transition-colors text-left"
          >
            <div className={`${opt.bg} p-2 rounded-lg shrink-0`}>
              <opt.icon className={`w-5 h-5 ${opt.color}`} />
            </div>
            <div>
              <div className="font-medium text-sm">{opt.title}</div>
              <div className="text-xs text-muted-foreground">{opt.description}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
